
import { AsentamientoProps, defaultAsentamiento } from "../catalogos/AsentamientoInterface";

import { defaultTipoDomicilio, TipoDomicilioProps } from "../catalogos/TipoDomicilioInterface";

//Definición de defaults

export const defaultDomicilio = {    
    idDomicilio:       0,
    descripcion:       '',
    numero:            '',
    referencia:        '',
    latitud:           0,
    longitud:          0,
    idAsentamiento:    0,
    asentamiento:      defaultAsentamiento,
    idTipoDomicilio:   0,
    tipoDomicilio:     defaultTipoDomicilio,
}

// Creación de interfaces

export interface DomicilioProps {    
    idDomicilio?:       number;
    descripcion?:       string;
    numero?:            string;
    referencia?:        string;
    latitud?:           number;
    longitud?:          number;
    idAsentamiento?:    number;
    asentamiento?:      AsentamientoProps;
    idTipoDomicilio?:   number;
    tipoDomicilio?:     TipoDomicilioProps;
}